import type { SignUpConfig } from '#types/config/components/form/signUp'
import type { RecursivePartial } from '#types/utils'

export default {
  agreementCheckboxes: [
    {
      locales: [
        'da-dk',
        'de-at',
        'de-be',
        'de-ch',
        'de-lu',
        'en-ch',
        'en-dk',
        'en-ie',
        'en-se',
        'fr-be',
        'fr-ch',
        'fr-lu',
        'it-ch',
        'nl-be',
        'nl-lu',
        'pt-pt',
        'sv-se'
      ],
      required: true,
      type: 'termsConditionsAndPolicy'
    },
    {
      type: 'loyaltyTerms',
      locales: ['de-de', 'en-gb', 'es-es', 'fr-fr', 'it-it', 'nl-nl'],
      required: true
    },
    {
      type: 'newsletter',
      locales: [
        'da-dk',
        'de-at',
        'de-be',
        'de-ch',
        'de-de',
        'de-lu',
        'en-ca',
        'en-ch',
        'en-dk',
        'en-gb',
        'en-ie',
        'en-se',
        'en-us',
        'es-es',
        'es-us',
        'fr-be',
        'fr-ca',
        'fr-ch',
        'fr-fr',
        'fr-lu',
        'it-ch',
        'it-it',
        'nl-be',
        'nl-lu',
        'nl-nl',
        'pt-pt',
        'sv-se'
      ]
    },
    {
      type: 'loyaltyTerms',
      locales: ['en-us', 'es-us'],
      required: true
    },
    {
      type: 'policy',
      locales: ['en-ca', 'en-us', 'es-us', 'fr-ca'],
      required: true
    }
  ],
  brandClasses: {
    submitButton: 'mt-4'
  },
  checkboxSize: 'sm',
  checkboxSizeSms: 'sm',
  fieldsOrder: [
    'firstName',
    'lastName',
    'birthDate',
    'phone',
    'gender',
    'email',
    'password'
  ],
  gender: {
    options: [
      { value: 'M', label: 'male' },
      { value: 'F', label: 'female' },
      { value: 'NA', label: 'preferNotToAnswer' }
    ],
    requiredLocales: [
      'da-dk',
      'de-at',
      'de-be',
      'de-ch',
      'de-de',
      'de-lu',
      'en-ch',
      'en-dk',
      'en-gb',
      'en-ie',
      'en-se',
      'es-es',
      'fr-be',
      'fr-ch',
      'fr-fr',
      'fr-lu',
      'it-ch',
      'it-it',
      'nl-be',
      'nl-lu',
      'nl-nl',
      'pt-pt',
      'sv-se'
    ]
  },
  loyaltyAgreementCheckboxes: [
    {
      type: 'loyaltyTerms',
      locales: ['en-us', 'es-us'],
      required: true
    },
    {
      type: 'loyaltyTerms',
      locales: ['de-de', 'en-gb', 'es-es', 'fr-fr', 'it-it', 'nl-nl'],
      required: true
    }
  ],
  minimalAge: 18,
  onSuccessNavigateTo: '/account',
  showBirthDateField: true,
  showSmsSectionLocales: ['en-us', 'es-us']
} satisfies RecursivePartial<SignUpConfig>
